import { ApplicationState } from "../../app/store";

export const selectUser = (store: ApplicationState) => store.user;
// export const isRole = (store: ApplicationState) => {
//     return user?.roles?.includes("ROLE_ADMIN");
// };
// export const selectIsAdmin = (store: ApplicationState): boolean => store.user?.roles?.includes("ROLE_ADMIN") == null ? false : store.user?.roles?.includes("ROLE_ADMIN");

export const selectIsAdmin = (store: ApplicationState): boolean => {
	return !!store.user?.admin;
};

export const selectIsOffice = (store: ApplicationState): boolean => {
	return !!store.user?.roles?.includes("OFFICE") && !store.user?.admin;
};

export const selectUserOrganizations = (store: ApplicationState) => store.user?.organizations;

export const hasRole = (role: string) => (store: ApplicationState) => !!store?.user?.roles?.includes(role);
